export const environment = {
  api_url: "https://api.demonstracao.ultracondominio.com.br/api/"
};
